var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
export default class TranscriptCourseStatusService {
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/transcriptCourseStatuses/search/findByNameLike", {
                params: { search },
            });
            return response.data._embedded.transcriptCourseStatuses;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/transcriptCourseStatuses/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.transcriptCourseStatuses;
        });
    }
    static search(search = {}, options = {}) {
        return FetchService.getPagedResponse("/aviso/transcriptCourseStatus/search", {
            ids: search.ids,
            descriptions: search.descriptions,
            integrationIds: search.integrationIds,
            query: search.query,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
}
